/**
 * CLS-DK help-center config (labels + routes).
 * Used by FAQ, Claims, Contact wrappers to render a shared sidebar.
 */
export const HELP_LABELS = {
  sidebarTitle: 'Populære emner',
  popular:      'Mest stillede',
  // Reklamation hidden — uncomment label + route (and restore the App.js route) to bring it back.
  // claims:       'Reklamation',
  contact:      'Kontakt os',
  sizeGuide:    'Størrelses guide',
  trykBroderi:  'Tryk & Broderi',
};

export const HELP_ROUTES = {
  faq:         '/clothing/cls-dk/faq',
  // claims:      '/clothing/cls-dk/claims',
  contact:     '/clothing/cls-dk/contact',
  sizeGuide:   '/clothing/cls-dk/size-guide',
  trykBroderi: '/clothing/cls-dk/tryk-broderi',
};
